import { AppCloudGroup } from '../Apps';
import AppManagementModel from './AppManagementModel';
import AppManagementRequest from './AppManagementRequest';

export default class AppCloudGroupRequest extends AppManagementRequest {
	/**
	 * 
	 * @param {AppManagementModel} app 
	 * @param {import('context/User/UserContext').ContextUser} createdBy 
	 * @param {object} AppCloudGroupXREF 
	 */
	constructor(app, createdBy, AppCloudGroupXREF) {
		super(app, createdBy);
		/**
		 * @type {AppCloudGroup}
		 */
		this.AppCloudGroupXREF = AppCloudGroupXREF
			? new AppCloudGroup(AppCloudGroupXREF)
			: new AppCloudGroup();
	}
}
